
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_k2y2q_iblzk_145",
  "checkbox-control": "awsui_checkbox-control_k2y2q_iblzk_178",
  "outline": "awsui_outline_k2y2q_iblzk_186"
};
  